import axios from '../../axios.js'

/**
 * Inbound SG Peppol BIS Ordering documents (the tenant is the SELLER).
 *
 * Read-only surface over the api-core `/peppol-inbound-orders` endpoints, which
 * expose received Order / OrderChange / OrderCancellation / OrderBalance records
 * and their lifecycle (RECEIVED / CHANGED / CANCELLED / RESPONDED / CONVERTED).
 * Reuses the IRSP_SUBMISSIONS permission server-side.
 */
export default {
  namespaced: true,

  state: {
    orders: [],
    pagination: {
      currentPage: 1,
      totalPage: 1,
      totalItem: 0,
      limit: 25,
    },
  },

  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = Array.isArray(orders) ? orders : []
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination }
    },
  },

  getters: {
    orders: (state) => state.orders,
    pagination: (state) => state.pagination,
  },

  actions: {
    /**
     * Fetch a paginated, filterable list of inbound orders.
     * API: GET /peppol-inbound-orders
     * @param {Object} payload - { page, limit, documentType[], status[], orderId, senderPid, search }
     */
    fetchRecords({ commit }, payload = {}) {
      const { page = 1, limit = 25, ...filters } = payload
      const params = { page, limit, ...filters }

      return axios
        .get('/peppol-inbound-orders', { params })
        .then((response) => {
          const body = response.data || {}
          commit('SET_ORDERS', body.data || [])
          commit('SET_PAGINATION', {
            currentPage: body.page || page,
            totalPage: body.totalPages || 1,
            totalItem: typeof body.total === 'number' ? body.total : (body.data || []).length,
            limit: body.limit || limit,
          })
          return response
        })
    },

    /**
     * Fetch a single inbound order by id.
     * API: GET /peppol-inbound-orders/:id
     */
    fetchRecord(context, id) {
      return axios.get(`/peppol-inbound-orders/${encodeURIComponent(id)}`).then((r) => r.data)
    },
  },
}
